<template>
  <el-container style="display: block;">
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">



      <el-row :span="2" style="margin-top: 30px;">
          名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          组名:<el-input v-model="gName" style="width: 150px;" placeholder="请输入名称"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          缩放尺:<el-input v-model="chi" style="width: 150px;" placeholder="请输入缩放尺"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          url:<el-input v-model="url" style="width: 150px;" placeholder="请输入url"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          指令:<el-input v-model="zhiling" style="width: 150px;" placeholder="请输入指令"></el-input>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            style="display: inline;">

            <img v-if="img1" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img1" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h1" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w1" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            style="display: inline;">

            <img v-if="img2" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img2" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h2" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w2" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess3"
            style="display: inline;">

            <img v-if="img3" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img3" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h3" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w3" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess4"
            style="display: inline;">

            <img v-if="img4" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img4" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h4" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w4" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess5"
            style="display: inline;">

            <img v-if="img5" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img5" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h5" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w5" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess6"
            style="display: inline;">

            <img v-if="img6" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img6" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h6" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w6" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess7"
            style="display: inline;">

            <img v-if="img7" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img7" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h7" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w7" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
            :show-file-list="false"
            :on-success="handleAvatarSuccess8"
            style="display: inline;">

            <img v-if="img8" :src="'http://fencip.yoooooo.com/tui_liebiao/'+img8" class="avatar" style="width: 100px;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="text-align: center;margin-top: 38px;"></i>
          </el-upload>
          <div style="float: left;width: 50px;">
            <el-input v-model="wh.h8" placeholder="高" style="width: 50px;"></el-input>
            <el-input v-model="wh.w8" placeholder="宽" style="width: 50px;"></el-input>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;margin-top: 30px;">
          <el-button type="primary" style="background-color: #409eff;" @click="addImg()" round>添加</el-button>
        </el-col>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="imgs"
            height="300"
          	border
          	style="width: 61%;margin-left: 0;height: 800px;text-align: center;">
          	<el-table-column
              prop="img1"
              width="150"
          	  label="正上"
          	   >
               <template slot-scope="scope">
                 <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img1" class="avatar" style="width: 50px;height: 50px;">
               </template>
          	</el-table-column>
          	<el-table-column
          	  prop="img2"
          	  width="150"
          	  label="左上"
          	   >
               <template slot-scope="scope">
                 <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img2" class="avatar" style="width: 50px;height: 50px;">
               </template>
          	</el-table-column>
             <el-table-column
               prop="img3"
               width="150"
               label="左侧"
                >
                <template slot-scope="scope">
                  <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img3" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img4"
               width="150"
               label="左下"
                >
                <template slot-scope="scope">
                  <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img4" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img5"
               width="150"
               label="正下"
                >
                <template slot-scope="scope">
                  <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img5" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img6"
               width="150"
               label="右下"
                >
                <template slot-scope="scope">
                  <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img6" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img7"
               width="150"
               label="右侧"
                >
                <template slot-scope="scope">
                  <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img7" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img8"
               width="150"
               label="右下"
                >
                <template slot-scope="scope">
                  <img  :src="'http://fencip.yoooooo.com/tui_liebiao/'+scope.row.img8" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               width="78"
               label="操作"
                >
                <template slot-scope="scope">
                  <i class="el-icon-delete" @click="delImgs(scope.$index)"></i>
                </template>
             </el-table-column>
            </el-table>
          </template>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-select v-model="groupNameg" @change="loadData()"  filterable placeholder="请选择分组" >
              <el-option
                v-for="item in groupName"
                :key="item.gname"
                :label="item.gname"

                :value="item.gname">
              </el-option>
            </el-select>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
      </el-row>
    </el-row>

    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="list"
        height="1500"
      	border
      	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
        <el-table-column

          width="100"
          label="组名"
           >
           <template slot-scope="scope">
               <div  @click="dischange(5,scope.row.gname,scope.row.id,1)">{{scope.row.gname}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="名称"
           >
           <template slot-scope="scope">
               <div  @click="dischange(1,scope.row.name,scope.row.id,1)">{{scope.row.name}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="缩放尺"
           >
           <template slot-scope="scope">
               <div  @click="dischange(2,scope.row.chi,scope.row.id,2)">{{scope.row.chi}}</div>
           </template>
        </el-table-column>
      	<el-table-column

          width="850"
      	  label="图片"
      	   >
          <template slot-scope="scope">

            <el-row>

              <el-col :span="20" style="text-align: center;margin-top: 20px;" @click.native="seeImg(scope.$index)">
                查看图片

              </el-col>
              <el-col :span="2" style="text-align: center;margin-top: 20px;" @click.native="kg(scope.row.id)">
                <span v-if="scope.row.status == 1" style="color: greenyellow;">开</span>
                <span v-if="scope.row.status == 2" style="color: crimson;">关</span>
              </el-col>




            </el-row>

          </template>
      	</el-table-column>
        <el-table-column

          width="100"
          label="url"
           >
           <template slot-scope="scope">
               <div  @click="dischange(6,scope.row.url,scope.row.id,2)">{{scope.row.url}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="指令"
           >
           <template slot-scope="scope">
               <div  @click="dischange(7,scope.row.zhiling,scope.row.id,2)">{{scope.row.zhiling}}</div>
           </template>
        </el-table-column>
        </el-table>
      </template>
      <div class="page">
      	<el-pagination
      	  @size-change="loadData()"
      	  @current-change="loadData()"
      	  :current-page.sync="page"
      	  :page-size="10"
      	  background
      	  layout="total,prev, pager, next, jumper"
      	  :total="count">
      	</el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看图片"
      :visible.sync="seeImgVis"
      width="60%"
      center>
      <el-row>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"
            :action="UploadUrls(imgSeeArr.id,1)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img1" :src="imgSeeArr.img1" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w1,imgSeeArr.id,1)">w:{{imgSeeArr.w1}}</div>
            <div @click="dischange(4,imgSeeArr.h1,imgSeeArr.id,1)">h:{{imgSeeArr.h1}}</div>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"

            :action="UploadUrls(imgSeeArr.id,2)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img2" :src="imgSeeArr.img2" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w2,imgSeeArr.id,2)">w:{{imgSeeArr.w2}}</div>
            <div @click="dischange(4,imgSeeArr.h2,imgSeeArr.id,2)">h:{{imgSeeArr.h2}}</div>
          </div>
        </el-col>

        <el-col :span="2" style="text-align: center;" >
          <el-upload
            class="avatar-uploader"

            :action="UploadUrls(imgSeeArr.id,3)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img3" :src="imgSeeArr.img3" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w3,imgSeeArr.id,3)">w:{{imgSeeArr.w3}}</div>
            <div @click="dischange(4,imgSeeArr.h3,imgSeeArr.id,3)">h:{{imgSeeArr.h3}}</div>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"

            :action="UploadUrls(imgSeeArr.id,4)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img4" :src="imgSeeArr.img4" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w4,imgSeeArr.id,4)">w:{{imgSeeArr.w4}}</div>
            <div @click="dischange(4,imgSeeArr.h4,imgSeeArr.id,4)">h:{{imgSeeArr.h4}}</div>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"

            :action="UploadUrls(imgSeeArr.id,5)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img5" :src="imgSeeArr.img5" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w5,imgSeeArr.id,5)">w:{{imgSeeArr.w5}}</div>
            <div @click="dischange(4,imgSeeArr.h5,imgSeeArr.id,5)">h:{{imgSeeArr.h5}}</div>
          </div>
        </el-col><el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"

            :action="UploadUrls(imgSeeArr.id,6)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img6" :src="imgSeeArr.img6" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w6,imgSeeArr.id,6)">w:{{imgSeeArr.w6}}</div>
            <div @click="dischange(4,imgSeeArr.h6,imgSeeArr.id,6)">h:{{imgSeeArr.h6}}</div>
          </div>
        </el-col><el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"

            :action="UploadUrls(imgSeeArr.id,7)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img7" :src="imgSeeArr.img7" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w7,imgSeeArr.id,7)">w:{{imgSeeArr.w7}}</div>
            <div @click="dischange(4,imgSeeArr.h7,imgSeeArr.id,7)">h:{{imgSeeArr.h7}}</div>
          </div>
        </el-col>
        <el-col :span="2" style="text-align: center;">
          <el-upload
            class="avatar-uploader"

            :action="UploadUrls(imgSeeArr.id,8)"
            :show-file-list="false"
            :on-success="handleAvatarSuccessch"
            style="display: inline;">

            <img v-if="imgSeeArr.img8" :src="imgSeeArr.img8" style="width: 80px;height: 80px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="float: left;width: 50px;margin-top: 10px;">
            <div @click="dischange(3,imgSeeArr.w8,imgSeeArr.id,8)">w:{{imgSeeArr.w8}}</div>
            <div @click="dischange(4,imgSeeArr.h8,imgSeeArr.id,8)">h:{{imgSeeArr.h8}}</div>
          </div>
        </el-col>





      </el-row>
    </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
         name:'',
         disName:'',
         list:[],
         img1:'',
         img2:'',
         img3:'',
         img4:'',
         img5:'',
         img6:'',
         img7:'',
         img8:'',
         imgs:[],
         disDialogVisible:false,
         disId:0,
         chi:'0',
         t:0,
         wh:{'h1':0,'w1':0,'h2':0,'w2':0,'h3':0,'w3':0,'h4':0,'w4':0,'h5':0,'w5':0,'h6':0,'w6':0,'h7':0,'w7':0,'h8':0,'w8':0},
         dist:0,
         seachName:'',
         gName:'',
         groupName:'',
         groupNameg:'',
         seeImgVis:false,
         imgSeeArr:[],
         url:'无',
         zhiling:'无'



      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
      var lett = this;
       document.onkeydown = function(e) {
       var key = window.event.keyCode;
       if (key == 13) {
         lett.seach();
       }
      }
    },

	methods:{
    seeImg(index){
      this.seeImgVis = true
      this.imgSeeArr =  this.list[index]





    },
    kg(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtskgChanges'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadData()

      	}else{
          this.$message({
          	type: 'error',
          	message: '操作失败'
          });
      	}

      })
      .catch(err=>{

      });
    },
    seach(){
      this.loadData();
    },

    UploadUrladd(id){
       return "http://fencip.yoooooo.com/index.php/index/data/pythonImgChangeAdd?t=2&id="+id
    },
    UploadUrls(id,n){
       return "http://fencip.yoooooo.com/index.php/index/data/pythondtsChanges?t="+n+"&id="+id
    },
    dischange(t,name,id,d){
      this.dist = d
      this.t = t;
      this.disId = id
      this.disName = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disId,
          dist:this.dist,
          name:this.disName,
          t:this.t
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtsChanges'
      })
      .then(res=>{
        if(res.data.code != 200){
          this.msg('操作失败','error');
        }else{
          this.loadData()
        }
        this.disDialogVisible = false
        this.seeImgVis = false

      })
      .catch(err=>{

      });
    },
    delImgs(index){
      this.imgs.splice(index,1);
    },
    addImg(){
      if(this.imgs.length > 0){
        this.msg('error','只能上传一组图片')
        return false
      }
      this.imgs.push({'img1':this.img1,'img2':this.img2,'img3':this.img3,'img4':this.img4,'img5':this.img5,'img6':this.img6,'img7':this.img7,'img8':this.img8})

    },
    handleAvatarSuccess1(res, file){
      this.img1 = file.response.data;
    },
    handleAvatarSuccess2(res, file){
      this.img2 = file.response.data;
    },
    handleAvatarSuccess3(res, file){
      this.img3 = file.response.data;
    },
    handleAvatarSuccess4(res, file){
      this.img4 = file.response.data;
    },
    handleAvatarSuccess5(res, file){
      this.img5 = file.response.data;
    },
    handleAvatarSuccess6(res, file){
      this.img6 = file.response.data;
    },
    handleAvatarSuccess7(res, file){
      this.img7 = file.response.data;
    },
    handleAvatarSuccess8(res, file){
      this.img8 = file.response.data;
    },
    handleAvatarSuccessch(res, file) {
      this.seeImgVis = false
      this.loadData();
      // this.imageList.push(file.response.data)
    },
    handleAvatarSuccessadd(res, file) {
      this.loadData();
      // this.imageList.push(file.response.data)
    },




    clearFiles(){
      this.$refs['my-upload'].clearFiles();
    },
    handleRemove(file, fileList) {

      this.imageList = []
      fileList.forEach((item)=>{
        this.imageList.push(item.response.data)
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageList.push(file.response.data)
    },


    add(){
      if(this.name.length == 0){
        this.$message({
        	type: 'error',
        	message: '请填写名称'
        });
        return false
      }
      if(this.imgs.length == 0){
        this.$message({
        	type: 'error',
        	message: '请选择图片'
        });
        return false
      }
      var a =[]
      for(var i=0;i<this.imgs.length;i++){
        a.push(JSON.stringify(this.imgs[i]))
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          gname:this.gName,
          img:a.join('-'),
          name:this.name,
          chi:this.chi,
          url:this.url,
          zhiling:this.zhiling,
          wh:JSON.stringify(this.wh),
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtsAddsTB'
      })
      .then(res=>{
         this.loadData()
         this.name = ''
         this.imgs = []
         this.img1 = ''
         this.img2 = ''
         this.img3 = ''
         this.img4 = ''
         this.img5 = ''
         this.img6 = ''
         this.img7 = ''
         this.img8 = ''
         this.timeStr = ''
         this.times = []
         this.clearFiles()
      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          name:this.seachName,
          p:this.page,
          type:1,
          gname:this.groupNameg
    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/elementdtsListsNew'
    	})
    	.then(res=>{
        this.groupName = res.data.group;
        this.list = res.data.list;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;

        })
        this.count = res.data.count;
    		// this.list = res.data;

    	})
    	.catch(err=>{

    	});
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/main/elementdts.vue